import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNewTabIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	"aria-label": "(opens in a new tab)",
	xmlns: "http://www.w3.org/2000/svg",
	width: 13,
	height: 13,
	viewBox: "0 0 13 13",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			fill: "currentColor",
			fillRule: "nonzero",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M502.937 757.875c.725 0 1.313-.588 1.313-1.312v-9.625c0-.725-.588-1.313-1.313-1.313h-9.625c-.724 0-1.312.588-1.312 1.313v9.625c0 .724.588 1.312 1.312 1.312h9.625zm-.164-1.312h-9.296c-.091 0-.165-.074-.165-.165v-9.296c0-.091.074-.164.165-.164h9.296c.091 0 .164.073.164.164v9.296c0 .091-.073.165-.164.165zm-6.97-1.41l3.944-3.942 1.318 1.318c.205.205.56.06.56-.232v-3.719c0-.181-.147-.328-.328-.328h-3.718c-.292 0-.44.354-.232.56l1.317 1.318-3.943 3.943c-.128.128-.128.336 0 .464l.619.619c.128.128.336.128.464 0z",
				transform: "translate(-492.000000, -745.000000)"
			})
		})
	})
});
export default SvgNewTabIcon;
